export default {
    methods: {
        show() {
            document.documentElement.style.overflowY = "hidden"
            document.documentElement.style.height = "100vh"

            this.$modal.show(this.modalId);
        },

        close() {
            this.$modal.hide(this.modalId);
        },

        handleClose() {
            document.documentElement.style.overflowY = "auto"
            document.documentElement.style.height = "auto"
        }
    }
}